const init = () => {
  let count = 0
  const interval = setInterval(async () => {
    const categorySelectEl = document.querySelector('#ja-def-20965') || document.querySelector('#ja-def-21665')
    const keywordInputEl = document.querySelector('#ja-keywords')
    if (categorySelectEl && keywordInputEl) {
      clearInterval(interval)
      editLabel(categorySelectEl, 'Department')
      setPlaceHolder(keywordInputEl, 'Keyword(s)')
      style(keywordInputEl)
    }
    if (count > 3000) {
      clearInterval(interval)
    }
    count++
  }, 100)
}

const onJobDetails = () => {
  const carrerHeaderEl = document.querySelector('.carrers')
  carrerHeaderEl.classList.add('hide')
}

const editLabel = (elm, label) => {
  const option = elm.querySelector('option[value="0"]')
  option.innerHTML = label
}

const setPlaceHolder = (elm, placeHolder) => {
  elm.setAttribute('placeholder', placeHolder)
}

const style = (keywordElm) => {
  const fieldContainer = keywordElm.closest('.ja-field-container')
  fieldContainer.style.width = 'calc(50% - 134px)'

  const carrerHeaderEl = document.querySelector('.carrers')
  carrerHeaderEl.classList.remove('hide')
}

const watchElementChange = (classEl, callback) => {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(addedNode) {
        const el = document.querySelector(classEl.replace(/^/, '.'))
        if (addedNode.parentElement && addedNode.parentElement.contains(el) && typeof callback === 'function') callback()
      });
    });
  });
  
  observer.observe(document.body, {childList: true, subtree: true});
}

watchElementChange('ja-job-search', init)
watchElementChange('ja-job-details', onJobDetails)
